export const featuredProjectOne = {
  name: "Job's Ladder",
  description: 'This is the Company Managing Website to help the hr of the company. Where HR, Employees, and Job Seekers will connect to each other. Job Seeker will find their desired jobs and could apply for these.',
  img: [ "https://i.ibb.co/5M7jLsk/Screenshot-3-min.png",
  "https://i.ibb.co/4s4ZPjs/Screenshot-4-min.png",
  "https://i.ibb.co/bzzCKGF/Screenshot-3.png",
  "https://i.ibb.co/PDyt1hg/Screenshot-4.png",
  "https://i.ibb.co/BrhBg7W/Screenshot-5.png",
  "https://i.ibb.co/yRxFbMh/Screenshot-6.png",
  "https://i.ibb.co/7ygmj9H/Screenshot-7.png", ],
  liveLink: 'https://job-ledder.web.app/',
  gitRepoClient: 'https://github.com/shakil18046/Job-s-Ladder',
  gitRepoServer: 'https://github.com/shakil18046/jobs-ladder-server',
  detailsRoute: 'jobs-ladder',
  featured: true,
  category: 'org',
  technologyUsed: ["React",
  "Redux",
  "TailwindCSS",
  "Firebase",
  "NodeJS",
  "ExpressJS",
  "MongoDB",
  "Send In Blue",
  "JWT etc.",],
  specialty: [
    "An User can log in with different 3 roles. (HR, Employee, and Job Seeker).",
    "An Hr can post jobs with his requirements.",
    "A Job Seeker will see all the posted jobs and will be able to apply there.",
    " HR can manage the candidates. like sending them tasks or could remove them.",
    "Notify an Important task with their Email.",
    "HR can also send tasks or contact his company's employees.",
    "Secured Front-end Routes and back-end API's.",
  ]
}


export const featuredProjectTwo = {
  name: 'ByCycle Soul',
  description: 'A website for bycycle Parts manufacturer company build by react JS. Server side was built by express JS. an admin can manage the parts and a user can buy from there. also user have a profile page.',
  img: ['https://i.ibb.co/HXDMNfd/bycycle-soul-min.png', 'https://i.ibb.co/rHPHfgk/dashboard-bycycle.png', 'https://i.ibb.co/ThPm64d/product-details-min.png', 'https://i.ibb.co/R2RBfGH/client-review-min.png', 'https://i.ibb.co/7VGL5y8/register-page-min.png'],
  liveLink: 'https://bycycle-soul---manufacturing.web.app/',
  gitRepoClient: 'https://github.com/checkiamsiam/bycycle-soul-manufacturing',
  gitRepoServer: 'https://github.com/checkiamsiam/bycycle-soul-server',
  detailsRoute: 'bycyle-soul',
  featured: true,
  category: 'org',
  technologyUsed: ['React Js', 'Express Js', 'MongoDB Atlas', 'Node Js', 'Tailwind Css', 'Firebase Authentication', 'Heroku', 'Github'],
  specialty: [
    'Advance Secure Firebase Authentication',
    'Great Looking User Interface',
    'Amazing User Experience',
    'Secure Server By Jwt',
    'Admin and Member Differentiation',
    'Good Looking User Profile',
    'Amazing Database & ui intersection',
    'Advance Product Management Calculation'
  ]
}
export const featuredProjectThree = {
  name: 'Health Cure',
  description: "A website for Booking doctor's appointment online. it built by react JS. and Server side was built by express JS. an user can set a appointment for a doctor and will get response email for this",
  img: ['https://i.ibb.co/rtj5K2M/health-cure-min.png', 'https://i.ibb.co/QJ7jD33/doctor-portal-header.png' , 'https://i.ibb.co/jL4CqxW/booking-slots.png'],
  liveLink: 'https://health-cure-doctor-s-portal.web.app/',
  gitRepoClient: 'https://github.com/checkiamsiam/doctor-s-health-cure-project',
  gitRepoServer: 'https://github.com/checkiamsiam/health-cure-server',
  detailsRoute: 'health-cure',
  featured: true,
  category: 'org',
  technologyUsed: ['React Js', 'Express Js', 'MongoDB Atlas', 'Node Js', 'Tailwind Css', 'Firebase Authentication', 'Heroku', 'Stipe'],
  specialty: [
    'Advance Secure Firebase Authentication',
    'Great Looking User Interface',
    'Amazing User Experience',
    'Secure Server By Jwt',
    'Admin and Member Differentiation',
    'Good Looking Dashboard',
    'Amazing Database & ui intersection',
    'Advance Appointment Management By Date'
  ]
}
